@if (reviews) {
  <div>
    @for (r of reviews | skip : page * pageSize | take : pageSize; track r) {
      <div>
        @if (detailed) {
          <detailed-review-display [review]="r" [maxTextLength]="maxTextLength" (showMore)="modalReview = $event; modal.open();">
          </detailed-review-display>
        }
        @if (!detailed) {
          <public-review-display [review]="r"  [showTitle]="showTitle" [maxTextLength]="maxTextLength" (showMore)="modalReview = $event; modal.open();">
          </public-review-display>
        }
        <div class="review-devider">
          <div class="devider"></div>
        </div>
      </div>
    }
    @if (page > 0) {
      <button type="button" class="btn btn-secondary" (click)="page = page - 1;">
      Show Previous Reviews</button>
    }
    @if (reviews.length > (page + 1) * pageSize) {
      <button type="button" class="btn btn-secondary" (click)="page = page + 1;">
      Show More Reviews</button>
    }
  </div>
}
<ng-template #modalDiv>
  <div class="modal-header">
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
  </div>
  <div class="modal-body">
    @if (modalReview && detailed) {
      <detailed-review-display [review]="modalReview">
      </detailed-review-display>
    }
    @if (modalReview && !detailed) {
      <public-review-display [review]="modalReview">
      </public-review-display>
    }
  </div>
</ng-template>
